import * as React from "react";
import { format, parseISO, isValid } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/**
 * Single-date picker that stores its value as a YYYY-MM-DD string,
 * matching what the existing native <input type="date"> inputs produced.
 */
export function DatePicker({
  value,
  onChange,
  placeholder = "Pick a date",
  testid,
  className,
  disabled,
}) {
  const [open, setOpen] = React.useState(false);
  let date = null;
  if (value) {
    const parsed = parseISO(value);
    if (isValid(parsed)) date = parsed;
  }
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          disabled={disabled}
          data-testid={testid}
          className={cn(
            "h-10 w-full justify-start rounded-none bg-black border-[#222] text-white font-mono text-sm hover:bg-[#0d0d0d] hover:text-white",
            !value && "text-[#666]",
            className,
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4 text-[#666]" />
          {date ? format(date, "yyyy-MM-dd") : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-auto p-0 bg-[#0a0a0a] border-[#222] rounded-none text-white"
        align="start"
      >
        <Calendar
          mode="single"
          selected={date || undefined}
          onSelect={(d) => {
            onChange(d ? format(d, "yyyy-MM-dd") : "");
            setOpen(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
